import { graphql } from "relay-runtime";

export { default as default } from "./button";

export const Fragment = graphql`
  fragment DatasetVersionPublishButtonFragment on DatasetVersion {
    id
    version
    publishable @ifAllowed
    viewerCanPublishDatasetVersion: viewerCan(action: PUBLISH_DATASET_VERSION)
  }
`;

export const Query = graphql`
  query DatasetVersionPublishButtonQuery($datasetVersionId: ID!) {
    node(id: $datasetVersionId) {
      ... on DatasetVersion @alias(as: "datasetVersion") {
        license
        ...datasetVersionCitationFragment
        ...datasetVersionAuthorsFragment

        dataset {
          private
          ...taggableFragment
        }
      }
    }
  }
`;

export const Mutation = graphql`
  mutation DatasetVersionPublishButtonMutation(
    $id: ID!
    $input: UpdateDatasetVersionInput!
  ) {
    updateDatasetVersion(datasetVersionId: $id, input: $input) {
      id
    }
    publishDatasetVersion(datasetVersionId: $id) {
      id
      publishedAt
      ...datasetVersionAuthorsFragment
    }
  }
`;
